import React from "react"
import { Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import { mdiFile } from "@mdi/js"

import { TechnicalDetails as TechnicalDetailsInterface } from "@secureo/common/typings/Product"

const useStyles = makeStyles()({
	responsiveTechDetails: {
		display: "flex",
		alignItems: "center",
		background: "white",
		borderRadius: 5,
		width: "100%",
		marginBottom: 3,
		"@media only screen and (max-width: 960px)": {
			display: "block",
		},
	},
})

const TechnicalDetails = ({ technicalDetails }: Props) => {
	const { classes } = useStyles()

	return (
		<div>
			{Object.entries(technicalDetails).map(([name, value]) => {
				return (
					<Box key={name} px={1} className={classes.responsiveTechDetails}>
						<Box
							mr={1}
							style={{
								display: "flex",
								alignItems: "center",
								minWidth: 240,
							}}
						>
							<Icon path={mdiFile} size={1} color="#4691CE" />
							<Box ml={1} my={2}>
								<strong>{name}</strong>
							</Box>
						</Box>
						<Box py={1}>{value}</Box>
					</Box>
				)
			})}
		</div>
	)
}

interface Props {
	technicalDetails: TechnicalDetailsInterface
}

export default TechnicalDetails
